import styled from 'styled-components'

const pageWidth = '842px'

export const SystemAuditContainer = styled.div`
    padding-top: 35px;
    /* display: flex; */
    width: 100%;
    background: ${({ theme }) => theme['gray-300']};
`

export const PdfTableContainer = styled.div`
    width: ${pageWidth};

    .export-pdf {
        background: blue;
        &,
        td,
        th {
            border-bottom: 1px solid var(--gray-400);
            text-align: left;
            padding: 8px;
            height: calc(596px / 8) !important;
            line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            background: red !important;
        }
    }
`
